import "./styles.scss";

import { Text, Button } from "@fragments";
import { TimeSeriesChart } from "@charts";
import {
  IconChartHistogram,
  IconArrowUpRight,
  IconCash,
} from "@tabler/icons-react";

/**
 * §6.11 — community revenue around the mentoring. A neutral promo card linking
 * to the full /insights page (filters prefilled) sits above a monthly revenue
 * chart that marks the month the mentoring started with a vertical indicator.
 */
export default function RevenueSection({
  revenue,
  loading,
  communityName,
  startDateLabel,
  referenceDate,
  onOpenInsights,
}) {
  return (
    <section className="cm-revenue">
      {/* Neutral link card — surface-elevation only, no primary fills. */}
      <div className="cm-revenue-promo">
        <div className="cm-revenue-promo-main">
          <span className="cm-revenue-promo-icon">
            <IconChartHistogram size={20} />
          </span>
          <div className="cm-revenue-promo-text">
            <Text.h5 contrast={8} weight={500}>
              Visualize todos os insights da comunidade {communityName}
            </Text.h5>
          </div>
          <Button
            text="Ver insights"
            endIcon={<IconArrowUpRight />}
            color="inverse"
            highlightColor="current"
            onClick={onOpenInsights}
            preventLoading
          />
        </div>

        {/* Monthly revenue with the "Início da mentoria" reference line. */}
        <TimeSeriesChart
          title="Receita da comunidade"
          icon={<IconCash size={15} />}
          timeSeries={revenue}
          valueType="money"
          defaultMode="bar"
          report={revenue}
          reportLoading={loading}
          referenceLine={
            referenceDate
              ? {
                  date: referenceDate,
                  label: `Início da mentoria · ${startDateLabel}`,
                }
              : undefined
          }
        />
      </div>
    </section>
  );
}
